import { apiFetch } from "./client";

export interface MeOut {
  id: number;
  nombre: string;
  first_name: string;
  last_name: string;
  username: string;
  email: string;
  rol: string;
  foto_url: string;
  modulos_habilitados: string[] | null;
}

export async function getMe(): Promise<MeOut> {
  return apiFetch<MeOut>("/me/");
}

export async function updateMe(first_name: string, last_name: string, email: string): Promise<MeOut> {
  return apiFetch<MeOut>("/me/", {
    method: "PATCH",
    body: JSON.stringify({ first_name, last_name, email }),
  });
}

export async function uploadFoto(file: File): Promise<{ foto_url: string }> {
  const form = new FormData();
  form.append("foto", file);
  return apiFetch<{ foto_url: string }>("/me/foto/", {
    method: "POST",
    body: form,
  });
}

export async function changePassword(
  current_password: string,
  new_password: string,
): Promise<void> {
  await apiFetch("/me/password/", {
    method: "POST",
    body: JSON.stringify({ current_password, new_password }),
  });
}
